import { useSplashBlocker } from '@app/core/splash/useSplashBlocker';
import { getQueryParam } from '@mi-front/core';
import { PropsWithChildren } from 'react';

/**
 * Returns true when `preview_splash` has a truthy value that is not an explicit
 * off (`0` / `false`). Bare `?preview_splash` is ignored (disabled).
 */
function isPreviewSplashEnabled(): boolean {
  const value = getQueryParam('preview_splash');
  if (!value) {
    return false;
  }
  return value !== '0' && String(value).toLowerCase() !== 'false';
}

/**
 * Forces the branded splash when `?preview_splash=1` (or `true`) is set, so style
 * can be reviewed without waiting for a real bootstrap load. Uses SplashOverlay.
 */
export function SplashPreviewGate({ children }: PropsWithChildren<object>) {
  const preview = isPreviewSplashEnabled();
  useSplashBlocker('preview', preview);

  if (preview) {
    return null;
  }

  return <>{children}</>;
}
